import { Message } from '@ipfabric/ui-components/Message/Message';
import { reservedLabelOverrideWarning } from '@ipfabric/utils/labels';

type ReservedLabelOverrideWarningProps = {
  names: readonly string[];
};

export const ReservedLabelOverrideWarning = ({
  names,
}: ReservedLabelOverrideWarningProps) => {
  const uniqueNames = [...new Set(names)];
  if (uniqueNames.length === 0) {
    return null;
  }

  return (
    <div data-testid='reserved-label-override-warning'>
      {uniqueNames.map((name) => (
        <Message
          key={name}
          message={reservedLabelOverrideWarning(name)}
          type='warning'
          variant='plain'
        />
      ))}
    </div>
  );
};
